document.addEventListener('DOMContentLoaded', () => {
    let indexCanvas = document.getElementById('webgl1');
    if (indexCanvas && typeof MoleculeRenderer !== 'undefined') {
        MoleculeRenderer.render(indexCanvas, {
            width: 500,
            height: 500,
            params: {
                GLOW_LEVEL: 5.0,
                MARGIN_CSS: 0.0,
                DISTORTION_STRENGTH: 0.18,
                NOISE_SCALE: 4.3,
                TIME_SPEED: 0.5,
                ROTATION_SPEED: 0.6,
                ZOOM: 0.4,
                CONTOUR_FREQUENCY: 7.0,
                CONTOUR_THICKNESS: 0.07,
                CONTOUR_BRIGHTNESS: 1.3,
                CONTOUR_FLOW_SPEED: 0.0,
                COLOR_BASE: '#193a61',
                COLOR_GLOW: '#75baff'
            }
        });
    }
});
